import React, { useMemo } from 'react'

import PropTypes from 'prop-types'

import DialogTitle from '@material-ui/core/DialogTitle'
import Typography from '@material-ui/core/Typography'

import { CloseIconButton, FullScreenIconButton, ExitFullScreenIconButton } from '@galo-monitor/web-components/IconButton'

import useStyles from './styles'

const HeaderTitleClose = (props) => {
  const {
    title,
    subTitle,
    disableTypography,
    titleClass,
    onClose,
    escape,
    containerClass,
    fullScreenButton,
    fullScreen,
    onChangeFullScreen
  } = props

  const classes = useStyles()

  const fullScreenIconButton = useMemo(() => {
    if (fullScreenButton) {
      let CustomButton = FullScreenIconButton
      if (fullScreen) {
        CustomButton = ExitFullScreenIconButton
      }
      return <CustomButton size="small" marginHorizontal marginVertical onClick={ onChangeFullScreen } />
    }
    return null
  }, [fullScreenButton, fullScreen, onChangeFullScreen])

  return (
    <div className={ [classes.header, containerClass].join(' ') }>
      <DialogTitle
        className={ [classes.title, titleClass].join(' ') }
        disableTypography={ disableTypography }
      >
        {title}
        {subTitle && (
          <Typography variant="body2">
            {subTitle}
          </Typography>
        )}
      </DialogTitle>
      {fullScreenIconButton}
      {escape ? (
        <CloseIconButton size="small" marginHorizontal marginVertical onClick={ onClose } />
      ) : null}
    </div>
  )
}

HeaderTitleClose.propTypes = {
  escape: PropTypes.bool.isRequired,
  disableTypography: PropTypes.bool,
  titleClass: PropTypes.string,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  subTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  onClose: PropTypes.func,
  containerClass: PropTypes.string,
  fullScreenButton: PropTypes.bool,
  fullScreen: PropTypes.bool.isRequired,
  onChangeFullScreen: PropTypes.func.isRequired
}

HeaderTitleClose.defaultProps = {
  disableTypography: false,
  title: null,
  subTitle: null,
  titleClass: null,
  onClose: () => {},
  containerClass: null,
  fullScreenButton: false
}

export default HeaderTitleClose
